import AxiosClient from "../../../services/axios.services";

class CompetenciesTypeServices {
  getCompetenciesType = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_tipo_competencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getCompetenciesTypeById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_tipo_competencia/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCompetenciesType = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_tipo_competencia/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editCompetenciesType = (id, data) =>
    AxiosClient.put(
      `/api/app/descriptor_perfil_tipo_competencia/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteCompetenciesType = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_tipo_competencia/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new CompetenciesTypeServices();
